var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPackage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_572_11128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7 3.67022L8.53839 0.298836C8.20374 0.11393 7.79756 0.11393 7.46291 0.298836L1.3013 3.67162C0.942906 3.86771 0.719675 4.24335 0.71875 4.65188V11.3484C0.719675 11.757 0.942906 12.1326 1.3013 12.3287L7.46291 15.7015C7.79756 15.8864 8.20374 15.8864 8.53839 15.7015L14.7 12.3287C15.0584 12.1326 15.2816 11.757 15.2826 11.3484V4.65258C15.2824 4.2433 15.0591 3.86667 14.7 3.67022ZM8.00066 1.27909L13.6259 4.3599L11.5415 5.5012L5.91551 2.42039L8.00066 1.27909ZM8.00066 7.44071L2.37538 4.3599L4.74901 3.06036L10.3743 6.14117L8.00066 7.44071ZM1.83904 5.34015L7.44051 8.40556V14.4124L1.83904 11.3491V5.34015ZM14.1623 11.3463L8.5608 14.4124V8.40836L10.8014 7.18234V9.6813C10.8014 10.1125 11.2682 10.382 11.6416 10.1664C11.8149 10.0663 11.9217 9.88142 11.9217 9.6813V6.56898L14.1623 5.34015V11.3456V11.3463Z",
    fill: "#1863DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_11128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPackage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Package.ca86062b.svg";
export { ForwardRef as ReactComponent };